import React from "react";

import { A } from "./strings";

/** The keep periods an Izba admin can pick (days); the server allows 1–90. */
export const KEEP_DAY_OPTIONS = [1, 3, 7, 14, 30, 60, 90];

/** The server's default when an organization has never been set. */
export const DEFAULT_KEEP_DAYS = 7;

interface Props {
  orgName: string;
  schema: string;
  days: number;
  disabled: boolean;
  /** The value picked and waiting on its confirm: shown instead of the saved one. */
  picked?: number | null;
  /** A new value was picked; the parent asks to confirm before saving. */
  onPick: (days: number) => void;
}

/** "Keep unused uploads: [N] days" (failure audit Q3). */
const KeepUploadsCell: React.FC<Props> = ({
  orgName,
  schema,
  days,
  disabled,
  picked = null,
  onPick,
}) => {
  const selectId = `keep-days-${schema}`;
  const shown = picked ?? days;
  const options = KEEP_DAY_OPTIONS.includes(days)
    ? KEEP_DAY_OPTIONS
    : [...KEEP_DAY_OPTIONS, days].sort((a, b) => a - b);
  return (
    <div className="space-y-1" data-testid={`keep-${schema}`}>
      <div className="flex flex-wrap items-center gap-1.5 text-sm text-gray-700">
        <label htmlFor={selectId}>{A.keepLabel}</label>
        <select
          id={selectId}
          aria-label={A.keepSelect(orgName)}
          value={shown}
          disabled={disabled}
          onChange={e => {
            const next = Number(e.target.value);
            if (next !== shown) onPick(next);
          }}
          className="rounded-md border border-gray-300 bg-white px-2 py-1 text-sm focus:border-blue-500 focus:outline-none disabled:opacity-50"
        >
          {options.map(n => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
        <span>{A.refreshDaysUnit}</span>
      </div>
      <div className="text-xs text-gray-500">{A.keepHint}</div>
    </div>
  );
};

export default KeepUploadsCell;
